import { render, staticRenderFns } from "./shop-cart.vue?vue&type=template&id=39b5d1fa&scoped=true"
import script from "./shop-cart.vue?vue&type=script&lang=js"
export * from "./shop-cart.vue?vue&type=script&lang=js"
import style0 from "./shop-cart.vue?vue&type=style&index=0&id=39b5d1fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b5d1fa",
  null
  
)

export default component.exports